/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EmailNotificationCategory {
    getFixupPrototypeFunction() { return EmailNotificationCategory.fixupPrototype; }

    static newInstance(model: Partial<EmailNotificationCategory>): EmailNotificationCategory {
        let obj = Object.assign(new EmailNotificationCategory(), model);
        EmailNotificationCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EmailNotificationCategory>): EmailNotificationCategory {
        if (!model) return null;
        return EmailNotificationCategory.newInstance(<EmailNotificationCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EmailNotificationCategory) {
        if (!obj) return;

        models.EmailNotificationCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EmailNotificationCategory): boolean {
        Object.setPrototypeOf(obj, EmailNotificationCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.value) {
            for (let val of this.value) {
                models.EmailNotificationType.fixupPrototype(val);
            }
        }
    }

    /**
     * Display label for the category
     */
    label: string;

    /**
     * Unique identifier for the category
     */
    name: string;

    value: Array<models.EmailNotificationType>;

}
